/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Heading_BlankInputs */



/**
* | output |
* | --- |
* | "This page pulled a blank" |
*
* @param {Error_Heading_BlankInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_heading_blank = /** @type {((inputs?: Error_Heading_BlankInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Heading_BlankInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Seite hat eine Niete gezogen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette page a fait chou blanc")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("这个页面抽了张白卡")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("這個頁面抽到了白牌")
	if (locale === "ko") return /** @type {LocalizedString} */ ("이 페이지는 빈 카드를 뽑았습니다")
	return /** @type {LocalizedString} */ ("This page pulled a blank")
});